import styled, { css } from 'styled-components';

import { Accordion } from '@/components/Accordion';
import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';

export const Wrapper = styled(Container)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      background-color: ${theme.colors.white};
    }
  `}
`;

export const AccordionLeftFlexItem = styled(Box)`
  display: block;
`;

export const SectionsWrapper = styled(Flex)`
  flex-direction: column;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      flex-direction: row;
    }
  `}
`;

export const StyledAccordion = styled(Accordion)`
  .AccordionBox {
    ${({ theme }) => css`
      padding: ${theme.spacing(2)};
      background-color: ${theme.colors.secondaryLightGrey};
    `}
  }
`;
